<template lang="pug">
  section.l-privacy
    h1 個人情報の保護に関する基本方針（プライバシーポリシー）
    p {{ overview.company.name }}（以下「当社」とする。）は、当社が運営する「{{ overview.service.spotgig.name }}」ウェブサイト及びそれに付随するアプリに関するすべての製品およびサービス（以下「本サービス」とする。）におけるお客様情報を以下のプライバシーポリシーに基づいて適切に通り取り扱うものとします。またお客様から取得した個人情報を保護し適切な取り扱いに最大限の注意を払います。
    h3 1.個人情報の定義と取得する情報
    p ギグベース株式会社（以下「当社」といいます。）では、個人情報の保護に関する法律及びそのガイドラインその他関連する法規則（以下「関連法規則」といいます。）を遵守して、個人情報を厳格に管理します。なお、本基本方針は、当社が実施する全てのサービスにおいて適用いたします。

    h3 1. 個人情報の定義
    p 個人情報とは、それによって直接個人が特定され得る情報（氏名・住所・電話番号・住所・emailアドレス・性別・生年月日など）とその個人に属する情報（利用履歴・利用料金・興味ある分野など）及び、これ以外にもそれ単体では直接個人が特定出来ずとも、複合する事により個人情報となり得る情報も含まれます。

    h3 2. 個人情報の取得及び利用
    p 当社は、個人情報を取得する際には、その取得目的を明らかにして、適正な方法で取得いたします。取得した個人情報は、通知若しくは公表した利用目的の達成に必要な範囲でのみ利用し、関連法規則で定める場合を除き、それ以外の目的では利用しません。

    h3 3. 第三者提供
    p 当社は、以下のいずれかの場合を除いて、個人情報を第三者に提供いたしません。

    ul
      li 1）個人情報をお客様の同意を得た場合
      li 2）当社より第三者の企業等へ業務委託している場合
      li 3）裁判所・警察・その他の法律や条例などで認められた権限を持つ機関から要請がある場合
      li 4）関連法規則に基づく場合

    h3 4. 個人情報の安全管理方法
    p 当社は、個人情報の安全管理について、以下を徹底いたします。
    ul
      li 1）当社個人情報の安全管理に関する組織・責任体制を構築し、社内規程等を整備・周知徹底・運用するとともに、社内規程等は適宜見直しを行い、継続的に改善します。
      li 2）基本方針及び個人情報保護に関する社内規程等を周知徹底させるため、役員、従業員等に対して教育、研修を行います。 特定個人情報等を取り扱う者に対しても適切な教育、研修を実施します。
      li 3）当社が個人情報の取扱いを委託する場合は、個人情報の安全管理が図られるよう適切に監督いたします。
      li 4）情報セキュリティに関する環境の変化や個人情報の安全管理に関する法令・規範の改正に合わせて継続的に管理体制を見直し、個人情報の安全管理措置を講じます。万一漏えい等が発生した場合には、事案に応じて、速やかな是正措置を実施します。

    h3 5. 本基本方針の改定
    p 当社は、法改正や当社事業内容の変更、利用者の要望等により、本基本方針の内容を改善・改定する事があります。この場合には事前に改定内容を利用者に分かりやすい形で告知し、一定期間の猶予期間を持って新たな内容に変更します。

    h3 6. 個人情報の安全管理に関するご質問及び苦情窓口
    p 当社は、個人情報の安全管理に万全を期しますが、当社の個人情報の安全管理に関してご質問や苦情のお申出をいただいた際には、誠実かつ合理的に対応させていただきます。（ご質問及び苦情窓口）
    p 〒101-0061　東京都千代田区神田三崎町2-20-5 住友不動産水道橋西口ビル2階
    p ギグベース株式会社 個人情報担当者宛

    a(href="mailto:support@gigbase.jp") お問い合わせはこちら
    p 2019年1月21日制定

    h4.mt-5 個人情報の取り扱いについて
    ul
      li
        | １．当社の名称
        br
        | ギグベース株式会社
      li
        | ２．当社の個人情報保護管理者
        br
        |  担当部署：コーポレートコミュニケーション部
        br
        |  連絡先：TEL　03-5357-1325
        br
        |  FAX　03-5357-1323
      li
        | ３．利用目的について
        br
        |  弊社は、お客様の個人情報を、下記に定める利用目的のみに利用いたします。
        br
        |  　(1)　タレント情報：登録サポート業務、備品発送及び業務連絡のため
        br
        |  　(2)　従業者情報：人事労務管理、福利厚生及び健康管理のため
        br
        |  　(3)　応募者情報：採用活動のため
        br
        |  　(4)　問い合わせ情報：お問い合わせに関する回答、ご連絡のため
      li
        | ４．個人情報の取り扱いについて
        br
        | 弊社は、ご本人の同意を得ずに第三者には提供いたしません。
      li
        | ５．個人情報の取り扱いの委託について
        br
        | 弊社は、３．の利用目的の範囲で、弊社と同等の安全管理措置を講じていると評価し、契約を締結した委託先に個人情報を委託することがあります。
      li
        | ６．個人情報の開示等について
        br
        | 弊社が、直接取得した個人情報（委託情報を除きます）については、ご本人から、利用目的の通知、開示、内容の訂正、追加又は削除、利用の停止、消去及び第三者への提供の停止（以下、開示等という）の求めに速やかに応じます。詳細は「開示等の手続き」をご参照ください。
      li
        | ７．個人情報に関する任意性
        br
        | 個人情報の取り扱いについては、ご本人の任意性を尊重します。ただし、必要な個人情報を弊社が取得できないときには、意図されたサービスを受けられない場合がありますので、ご了承ください。
      li ８．弊社のホームページでは、ご本人が容易に認識できない方法によって個人情報を取得する仕組みは設置しておりません。

    h4 開示等の手続き
    ul
      li
        | １．開示等の求めの申し出先
        br
        | 会社名：ギグベース株式会社
        br
        | 担当部署：コーポレートコミュニケーション部
        br
        | 連絡先：TEL 03-5357-1325
        br
        |  FAX 03-5357-1323
      li
        | ２．開示等の求めに際して提出すべき書面
        br
        | 　(1)　開示等請求書（兼）回答書
        br
        | 資料ダウンロードは
        a(href='http://docs.gigbase.jp/disclosure-request.pdf', target='_blank') こちら(PDF)
      li
        | ３．手数料
        br
        | ご本人から「利用目的の通知」および「開示」のご請求に応じる場合の手数料については、800円（税込み）とします。但し郵便でのご請求の場合、返信用封筒に84円分の切手を貼付して同封の上ご請求ください。 　制定日：2020年02月17日
    p
      | ■お問い合わせ
      br
      | 当社の個人情報保護方針あるいは当社保有の個人情報に関するお問い合わせ等は、当社「個人情報相談窓口担当」までご連絡ください。
      br
      | 個人情報相談窓口担当
      br
      | TEL　03-5357-1325
      br
      | FAX  03-5357-1323 
      br
      | 郵送 〒101-0061　東京都千代田区神田三崎町2-20-5 住友不動産水道橋西口ビル2階

</template>
<script lang="babel">
  import { mapGetters } from 'vuex'
  export default {
    data () {
      return {
         name: 'privacy'
      }
    },
    created () {
    },
    mounted () {
    },
    computed: {
      ...mapGetters('config', {
        overview: 'settings'
      }),
    },
    methods: {

    }
  }
</script>
<style lang="scss">

</style>
